import React from 'react';
import { FormatterType } from '@components/Table/types';
import { avTooltipProps } from '@components/WithDescriptionTooltip/constants';
import { StyledBadge, StyledBadgeProps } from '@components/WithDescriptionTooltip/StyledBadge';
import { StyledTooltipTitleWithIcon } from '@components/WithDescriptionTooltip/StyledTooltipTitleWithIcon';
import { AvTooltip, AvTooltipProps } from '@fabric-ui/components';
import { TooltipProps } from '@mui/material';

export type WithDescriptionTooltipProps = {
  /**
   * @description If `true`, will badgify the children with an icon and attach the tooltip to it. otherwise attaches the tooltip to the children.
   * @default false
   */
  badgify?: boolean;
  badgeProps?: StyledBadgeProps;
} & TooltipProps;

function WithDescriptionTooltip({ badgify = false, children, badgeProps, ...props }: WithDescriptionTooltipProps) {
  if (badgeProps?.type !== FormatterType.date && !props.title) {
    return children;
  }

  if (badgify) {
    return (
      <StyledBadge tooltipProps={props} {...badgeProps}>
        {children}
      </StyledBadge>
    );
  }

  const { title, ...rest } = props;
  return (
    <AvTooltip
      {...avTooltipProps}
      muiProps={{ ...avTooltipProps.muiProps, ...rest } as AvTooltipProps['muiProps']}
      title={title ? <StyledTooltipTitleWithIcon>{title}</StyledTooltipTitleWithIcon> : title}>
      {children}
    </AvTooltip>
  );
}

export default WithDescriptionTooltip;
